"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _createIconComponent = _interopRequireDefault(require("./utils/createIconComponent"));

var _react = _interopRequireDefault(require("react"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

var IconParagraph = (0, _createIconComponent["default"])({
  content: _react["default"].createElement("g", null, _react["default"].createElement("path", {
    d: "M53.08 10.46H27.47a12.49 12.49 0 0 0 0 25h5.59V57.6a1.94 1.94 0 1 0 3.88 0V14.34h5.16V57.6a1.94 1.94 0 1 0 3.88 0V14.34h7.1a1.94 1.94 0 1 0 0-3.88zm-20 21.09h-5.61a8.61 8.61 0 0 1 0-17.22h5.59z"
  })),
  height: undefined,
  width: undefined
});
IconParagraph.displayName = 'IconParagraph';
var _default = IconParagraph;
exports["default"] = _default;


//////////////////
// WEBPACK FOOTER
// ./~/@tecuity/sos-icons/react/paragraph.js
// module id = 582
// module chunks = 0